import { Component } from "react";
import "../dash.css"
import DashHeader from "../../component/dash_header";
import DashMenu from "../../component/dash_menu";
import BitcoinChart from "../../component/trading_chart";
// import { MdSupportAgent } from "react-icons/md";
// import {Link} from "react-router-dom"

// import { TbListDetails } from "react-icons/tb";

import { MdAccountBalanceWallet } from "react-icons/md";
import { Link } from "react-router-dom";
// import axios from "axios";
import NumberDisplay from "../../component/numberDisplay";
import BitcoinConverter from "../../component/bitcoinNumberDisplay";
import FormattedDate from "../../component/dateFormat";
import ChatBox from "../../component/chatbox";
import { connect } from "react-redux";



class Dashbaord extends Component {
    state = {
        user: {
            firstName: "",
            lastName: "",
            userPlan: ""
        },
        isMenuVisible: false,
        userInfo: [],
        windowWidth: window.innerWidth,
        loading: false,
        network: false
    };

    // Toggles the menu visibility
    toggleMenu = () => {
        this.setState((prevState) => ({
            isMenuVisible: !prevState.isMenuVisible
        }));
    };

    // Handle window resize event
    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    // Adjust menu visibility based on window width
    adjustMenuVisibility = () => {
        const { windowWidth, isMenuVisible } = this.state;
        if (windowWidth > 1100 && !isMenuVisible) {
            this.setState({ isMenuVisible: true });
        } else if (windowWidth <= 1100 && isMenuVisible) {
            this.setState({ isMenuVisible: false });
        }
    };

    // Clean up resize event listener when component unmounts
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    // Update menu visibility when window width changes
    componentDidUpdate(prevProps, prevState) {
        if (prevState.windowWidth !== this.state.windowWidth) {
            this.adjustMenuVisibility();
        }
         if (prevProps.user !== this.props.user) {
      this.setState({ userInfo: this.props.user });
    }
    }

    componentDidMount() {
        const savedUser = localStorage.getItem("teslaUserInfo");
        if (savedUser) {
            const userData = JSON.parse(savedUser);
            this.setState({
                user: {
                    firstName: userData.firstName || "",
                    lastName: userData.lastName || "",
                    userPlan: userData.userPlan || ""
                }
            });
        }
        window.addEventListener("resize", this.handleResize);
        this.adjustMenuVisibility(); // Initial visibility check
        // this.fetchUserInfo();
         const { user } = this.props;
    if (user) {
      this.setState({ userInfo: user });
    }
    }


    // fetchUserInfo = async () => {
    //     this.setState({ loading: true });

    //     const accessToken = localStorage.getItem("teslaUserAccessToken"); // ✅ fixed key name

    //     try {
    //         const response = await axios.get("http://localhost:3001/api/userinfo", {
    //             headers: { Authorization: `Bearer ${accessToken}` }
    //         });

    //         if (response.data && response.data.user) {
    //             this.setState({ userInfo: response.data.user, loading: false });
    //         } else {
    //             // Fallback if user is not returned (avoid stuck loading)
    //             this.setState({ loading: false });
    //         }

    //         console.log("User information:", response.data.user);

    //     } catch (error) {
    //         // Always clear loading state
    //         this.setState({ loading: false });

    //         if (error.response && (error.response.status === 401 || error.response.status === 403)) {
    //             // ✅ Make sure to check error.response exists first
    //             localStorage.removeItem("teslaUserAccessToken");
    //             localStorage.removeItem("teslaUserInfo");
    //             // Optional: redirect or show login expired message
    //             window.location.href = "/login";
    //         } else {
    //             console.error("Error fetching user data:", error);
    //             this.setState({ network: true }); // optional network error flag
    //         }
    //     }
    // };


    // filterByStatus = (value) => {
    //     const event = this.props.event;
    //     return event.filter((item) =>
    //         String(item.status).toLowerCase().includes(String(value).toLowerCase())
    //     );
    // };



    render() {
        const { isMenuVisible, user, userInfo } = this.state
     

       const depositList = Array.isArray(userInfo?.deposit) && userInfo.deposit.length > 0
    ? [...userInfo.deposit]  // Create a shallow copy to avoid mutating original array
        .sort((a, b) => new Date(b.date) - new Date(a.date)) // Sort in descending order by date
        .map(list => {
            return (
                <li key={list.id}>
                    <h5>
                        {list.method}
                        <br />
                        <span><FormattedDate date={list.date} /></span>
                    </h5>
                    <p className="amount">${list.amount}</p>
                </li>
            )
        }) : (
            <div className="deposit_contain_list">
                <MdAccountBalanceWallet />
                <p>No deposits yet</p>
                <Link to="/deposit"><button>Deposit Now</button></Link>
            </div>
        );
            
        const withdrawList = Array.isArray(userInfo?.withdraw) && userInfo.withdraw.length > 0
    ? [...userInfo.withdraw]  // Prevent mutation of original array
        .sort((a, b) => new Date(b.date) - new Date(a.date))  // Sort by date descending
        .map(list => {
            return (
                <li key={list.id}>
                    <h5>
                        {list.method}
                        <br />
                        <span><FormattedDate date={list.date} /> </span>
                    </h5>
                    <h5>
                        ${list.amount}
                        <br />
                        <span className={`${
                            list.status === "Pending" ? "yellow" :
                            list.status === "Reverse" ? "red" :
                            list.status === "Complete" ? "green" :
                            "yellow"
                        }`}>
                            {list.status}
                        </span>
                    </h5>
                </li>
            )
        }) : (
            <div className="deposit_contain_list">
                <MdAccountBalanceWallet />
                <p>No withdrawals yet</p>
                <Link to="/withdrawal"><button>Withdraw</button></Link>
            </div>
        );


        return (
            <div className="dashboard">
                <DashHeader toggleMenu={this.toggleMenu} />
                <div className="dash_body_container">
                    <DashMenu isMenuVisible={isMenuVisible} toggleMenu={this.toggleMenu} />
                    <div className="dash_content_container">
                        <div className="dash_contain">
                            <div className="dash_head">
                                <h3 style={{textTransform: "capitalize"}}>Good Day {`${user.firstName} ${user.lastName}`}</h3>
                                <p>Welcome to Tesla Broker , one stop from your dream</p>
                            </div>

                            <div className="dash_record_container">
                                <nav className="record_contain">
                                    <h4>
                                        $ <NumberDisplay value={userInfo.walletDeposit} />
                                        <br />
                                        <span>Total Deposit</span><br />
                                        <span>BTC <BitcoinConverter value={userInfo.walletDeposit} /></span>
                                    </h4>
                                </nav>
                                <nav className="record_contain">
                                    <h4>
                                        $ <NumberDisplay value={userInfo.walletBalance} />
                                        <br />
                                        <span >Balance</span> <br />
                                        <span>BTC <BitcoinConverter value={userInfo.walletBalance} /></span>
                                    </h4>
                                </nav>
                                <nav className="record_contain">
                                    <h4>
                                        {userInfo.userPlan || ""}
                                        <br />
                                        <span>Crypto Plan</span>
                                    </h4>
                                </nav>
                            </div>




                            <div className="dash_table_container">
                                <section className="dash_contain">
                                    <div className="side_dash_table_cover">
                                        <div className="dash_cover">
                                            <h3>Live Bitcoin Candlestick Chart</h3>
                                            <p>Stay updated with live currency value </p>
                                            <div className="table_list" style={{ overflow: "hidden" }}>

                                                {/* <li>
                                                    <p className="long">Welcome to Campus Connect, one stop from event information </p>
                                                    <p className="short green">upcoming</p>
                                                </li> */}
                                                <BitcoinChart />
                                            </div>
                                        </div>
                                    </div>
                                </section>


                                <section className="dash_contain">
                                    <div className="side_dash_table_cover">
                                        <div className="dash_cover small">
                                            <h3>Deposit</h3>
                                            <p>Recent deposit successfully made.</p>
                                            <div className="table_list">

                                                {/* <li>
                                                    <h5>
                                                        Bitcoin
                                                        <br/>
                                                        <span>13/04/2025 10:00</span>
                                                    </h5>
                                                     <p className="amount">$1000.00</p>
                                                </li> */}
                                                {depositList}

                                            </div>
                                        </div>
                                    </div>

                                    <div className="side_dash_table_cover">
                                        <div className="dash_cover small">
                                            <h3>Withdrawal</h3>
                                            <p>Recent withdrawal successfully made.</p>
                                            <div className="table_list">


                                                {withdrawList}

                                            </div>
                                        </div>
                                    </div>


                                </section>
                            </div>
                        </div>
                    </div>
                </div>
                <ChatBox />
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    user: state.user,
});



export default connect(mapStateToProps)(Dashbaord)